export const ORG_NAV = "ORG_NAV";
export const USERS_NAV = "USERS_NAV";
export const TOOLS_NAV = "TOOLS_NAV";
export const DEV_NAV = "DEV_NAV";
export const SETTINGS_NAV = "SETTINGS_NAV";
